/**
 * The exercise the sign-in window shows beside its form, a different one each time it opens. A small, curated set of
 * well-known library exercises with clean execution videos, copied from the library (meu-treino-api `exercises`):
 * the library itself needs an account, so the window can't ask the API for them.
 */
const MEDIA = 'https://media.meutreino.fit';

export const AUTH_EXERCISES = [
  {
    id: '79D0BB3A',
    title: 'Bench Press (Barbell)',
    titlePt: 'Supino Reto com Barra',
    muscle: 'chest',
    equipment: 'barbell',
    videoUrl: `${MEDIA}/exercise-assets/00251201-Barbell-Bench-Press_Chest.mp4`,
    thumbnailUrl: `${MEDIA}/exercise-thumbnails/00251201-Barbell-Bench-Press_Chest_thumbnail@3x.jpg`,
  },
  {
    id: 'D04AC939',
    title: 'Squat (Barbell)',
    titlePt: 'Agachamento com Barra',
    muscle: 'quadriceps',
    equipment: 'barbell',
    videoUrl: `${MEDIA}/exercise-assets/00431201-Barbell-Full-Squat_Thighs.mp4`,
    thumbnailUrl: `${MEDIA}/exercise-thumbnails/00431201-Barbell-Full-Squat_Thighs_thumbnail@3x.jpg`,
  },
  {
    id: '422B08F1',
    title: 'Lateral Raise (Dumbbell)',
    titlePt: 'Elevação Lateral com Halteres',
    muscle: 'shoulders',
    equipment: 'dumbbell',
    videoUrl: `${MEDIA}/exercise-assets/03341201-Dumbbell-Lateral-Raise_shoulder.mp4`,
    thumbnailUrl: `${MEDIA}/exercise-thumbnails/03341201-Dumbbell-Lateral-Raise_shoulder_thumbnail@3x.jpg`,
  },
  {
    id: '55E6546F',
    title: 'Bent Over Row (Barbell)',
    titlePt: 'Remada Curvada com Barra',
    muscle: 'upper_back',
    equipment: 'barbell',
    videoUrl: `${MEDIA}/exercise-assets/00271201-Barbell-Bent-Over-Row_Back.mp4`,
    thumbnailUrl: `${MEDIA}/exercise-thumbnails/00271201-Barbell-Bent-Over-Row_Back_thumbnail@3x.jpg`,
  },
  {
    id: '6A6C31A5',
    title: 'Lat Pulldown (Cable)',
    titlePt: 'Puxada Frontal na Polia',
    muscle: 'lats',
    equipment: 'machine',
    videoUrl: `${MEDIA}/exercise-assets/01501201-Cable-Bar-Lateral-Pulldown_Back.mp4`,
    thumbnailUrl: `${MEDIA}/exercise-thumbnails/01501201-Cable-Bar-Lateral-Pulldown_Back_thumbnail@3x.jpg`,
  },
  {
    id: '878CD1D0',
    title: 'Shoulder Press (Dumbbell)',
    titlePt: 'Desenvolvimento de Ombros com Halteres',
    muscle: 'shoulders',
    equipment: 'dumbbell',
    videoUrl: `${MEDIA}/exercise-assets/04051201-Dumbbell-Seated-Shoulder-Press_Shoulders.mp4`,
    thumbnailUrl: `${MEDIA}/exercise-thumbnails/04051201-Dumbbell-Seated-Shoulder-Press_Shoulders_thumbnail@3x.jpg`,
  },
];

// A random one, never the one the window showed last time
export const pickAuthExercise = (previousId, random = Math.random) => {
  const pool = AUTH_EXERCISES.filter((exercise) => exercise.id !== previousId);
  return pool[Math.min(pool.length - 1, Math.floor(random() * pool.length))];
};

// The two shown beside the window's exercise on the sign-up panel (not playing)
export const sideExercises = (exercise) => AUTH_EXERCISES.filter((other) => other.id !== exercise.id).slice(0, 2);

// The video plays only when it's welcome: not under reduced motion, and not when the visitor saves data or is on a slow
// connection (the poster stays then)
export const shouldPlayExerciseVideo = (win = typeof window === 'undefined' ? undefined : window) => {
  if (!win) return false;
  if (win.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return false;
  const connection = win.navigator?.connection;
  if (connection?.saveData) return false;
  return !/(^|-)2g$/.test(connection?.effectiveType || '');
};
